import {
  EnterLayoutPage,
  LoginPage,
  FleetSafetyReports,
  VehicleSafetyReports,
  Reports,
} from '../pages';

import FleetReportsDrawer from '../pages/reports/FleetReports/drawer/FleetReportsDrawer';
import VehicleReportsDrawer from '../pages/reports/VehicleReports/drawer/VehicleReportsDrawer';
import { WeeklyReport } from '../pages/reports/ReportScreens/weekly-report/pages';
import { IcWeeklyReport } from '../pages/reports/ReportScreens/ic-weekly-report/pages';
import { Products } from '../pages';

const routes = [
  {
    path: '/',
    element: <Products />,
  },
  {
    path: '/login',
    element: (
      <EnterLayoutPage>
        <LoginPage />
      </EnterLayoutPage>
    ),
  },
  // {
  //   path: '*',
  //   element: <ErrorPage />,
  // },
  {
    path: '/kavi/dashboard',
    element: <Reports />,
  },
  {
    path: '/kavi/fleet-safety-reports',
    element: <FleetSafetyReports />,
    rightDrawerElement: <FleetReportsDrawer />,
    instanceCanView: ['amir-al0'],
  },
  {
    path: '/kavi/vehicle-safety-reports',
    element: <VehicleSafetyReports />,
    rightDrawerElement: <VehicleReportsDrawer />,
    instanceCanView: ['amir-al0'],
  },
  // {
  //   path: '/kavi/card-reports',
  //   element: <CardReports />,
  //   instanceCanView: ['amir-tr0'],
  // },
  // {
  //   path: '/kavi/voyage-reports',
  //   element: <VoyageReports />,
  //   // leftDrawerElement: <DriverDetailDrawer />,
  //   instanceCanView: ['amir-tr0'],
  // },
  // {
  //   path: '/kavi/transportation-safety-reports',
  //   element: <TransportationSafetyReports />,
  //   rightDrawerElement: <TransportationReportsDrawer />,
  //   instanceCanView: ['amir-al0'],
  // },
  // {
  //   path: '/kavi/transportation-report/:id',
  //   element: <TransportationReport />,
  //   instanceCanView: ['amir-al0'],
  // },
  {
    path: '/kavi/weekly-report/:id',
    element: <WeeklyReport />,
    instanceCanView: ['amir-al0'],
  },
  {
    path: '/kavi/ic-weekly-report/:id',
    element: <IcWeeklyReport />,
    instanceCanView: ['amir-al0'],
  },
  // {
  //   path: '/kavi/pusula/dashboard',
  //   element: <Pusula />,
  // },
  // {
  //   path: '/kavi/pusula/distribution',
  //   element: <Distribution />,
  // },
  // {
  //   path: '/kavi/pusula/createroute',
  //   element: <ServiceList />,
  // },
  // {
  //   path: '/kavi/pusula/shifts',
  //   element: <Shiftlist />,
  // },
  // {
  //   path: '/kavi/pusula/showdistributionvehicles/:id',
  //   element: <ShowVehicles />,
  // },
  // {
  //   path: '/kavi/pusula/showpassengers/:id',
  //   element: <ShowPassengers />,
  // },
  // {
  //   path: '/kavi/pusula/geocoder',
  //   element: <Geocoder />,
  // },
  // {
  //   path: '/umay/dashboard',
  //   instanceCanView: ['amir-al0'],
  //   element: <Kids />,
  // },

  // {
  //   path: '/atlas/dashboard',
  //   element: <Atlas />,
  // },
  // {
  //   path: '/atlas/dashboard/teams',
  //   element: <Teams />,
  //   //TODO: add permission to render
  //   rightDrawerElement: (
  //     <PermissionToRender>
  //       <CreateTeamDrawer />
  //     </PermissionToRender>
  //   ),
  // },
  // {
  //   path: '/atlas/dashboard/teams/:id',
  //   element: <TeamRecord />,
  // },
  // {
  //   path: '/atlas/dashboard/alarms',
  //   element: <Alarms />,
  //   rightDrawerElement: (
  //     <PermissionToRender>
  //       <CreateAlarmDrawer></CreateAlarmDrawer>
  //     </PermissionToRender>
  //   ),
  // },
  // {
  //   path: '/atlas/dashboard/alarms/:id',
  //   element: <AlarmRecord />,
  // },
  // {
  //   path: '/atlas/dashboard/observers/:id',
  //   element: <ObserverRecord />,
  // },
  // {
  //   path: '/atlas/dashboard/observers',
  //   element: <Observers />,
  //   rightDrawerElement: (
  //     <PermissionToRender>
  //       <CreateObserverDrawer></CreateObserverDrawer>
  //     </PermissionToRender>
  //   ),
  // },
  // {
  //   path: '/fuel/dashboard',
  //   instanceCanView: ['amir-al0'],
  //   element: <Fuel />,
  // },
  // {
  //   path: '/fuel/dashboard',
  //   instanceCanView: ['amir-al0'],
  //   element: <Fuel />,
  // },
  // {
  //   path: '/fuel/fuel-reports',
  //   instanceCanView: ['amir-al0'],
  //   element: <FuelReports />,
  //   rightDrawerElement: <FuelReportsDrawer />,
  // },
  // {
  //   path: '/fuel/fuel-report/:id',
  //   instanceCanView: ['amir-al0'],
  //   element: <FuelReport />,
  // },
  // {
  //   path: '/fuel/fuel-blacklist',
  //   instanceCanView: ['amir-al0'],
  //   element: <BlackList />,
  // },
  // {
  //   path: '/definitions/dashboard',
  //   element: <Definitions />,
  // },
  // {
  //   path: '/definitions/users',
  //   element: <Users />,
  //   rightDrawerElement: (
  //     <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //       <CreateUserDrawer />
  //     </PermissionToRender>
  //   ),
  //   // leftDrawerElement: (
  //   //   <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //   //     <EditUserDrawer />
  //   //   </PermissionToRender>
  //   // ),
  // },
  // {
  //   path: '/definitions/users/user-record/:id',
  //   element: <UserRecord />,
  //   roleCanView: 'KV_SUPERUSER',
  // },
  // {
  //   path: '/definitions/vehicles',
  //   element: <Vehicles />,
  //   rightDrawerElement: (
  //     <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //       <CreateVehicleDrawer />
  //     </PermissionToRender>
  //   ),
  //   // leftDrawerElement: (
  //   //   <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //   //     <EditVehicleDrawer />
  //   //   </PermissionToRender>
  //   // ),
  // },
  // {
  //   path: '/definitions/vehicles/vehicle-record/:id',
  //   element: <VehicleRecord />,
  //   roleCanView: 'KV_SUPERUSER',
  // },
  // {
  //   path: '/definitions/drivers',
  //   element: <Drivers />,
  //   rightDrawerElement: <CreateDriverDrawer />,
  // },
  // {
  //   path: '/definitions/devices',
  //   element: <Devices />,
  //   rightDrawerElement: (
  //     <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //       <CreateDeviceDrawer />
  //     </PermissionToRender>
  //   ),
  //   // leftDrawerElement: (
  //   //   <PermissionToRender roleCanView={'KV_SUPERUSER'}>
  //   //     <EditDeviceDrawer />
  //   //   </PermissionToRender>
  //   // ),
  // },
  // {
  //   path: '/definitions/devices/device-record/:id',
  //   element: <DeviceRecord />,
  //   roleCanView: 'KV_SUPERUSER',
  // },
  // {
  //   path: '/definitions/transportation-schemas',
  //   element: <TransportationSchemas />,
  // },
  // {
  //   path: '/pusula/dashboard',
  //   element: <Pusula />,
  // },
  // {
  //   path: '/pusula/offline-distribution',
  //   element: <OfflineDistribution />,
  // },
  // {
  //   path: 'pusula/offline-route',
  //   element: <OfflineRoute />,
  // },

  // {
  //   path: '/kavi/distribution',
  //   element: <Distribution />,
  // },
];

export default routes;
